module.exports = __webpack_public_path__ + "static/1-min-2177aeea4292371a12d4225bbf030f1d.jpeg";